import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faCartShopping } from '@fortawesome/free-solid-svg-icons'; 
import './Store.css';
import { useCart } from './CartContext';

function Store() {
  const { cartItems, addToCart, increaseQuantity, decreaseQuantity, removeFromCart } = useCart(); 
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSort, setSelectedSort] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [isCartVisible, setIsCartVisible] = useState(false);
  const [priceRange, setPriceRange] = useState({ min: 0, max: Infinity });

  const handleCategoryClick = (category) => {
    setSelectedCategory((prevCategory) => (prevCategory === category ? null : category));
  };

  const handleSortClick = (sortOption) => {
    setSelectedSort((prevSort) => (prevSort === sortOption ? null : sortOption));
  };

  const handleColorClick = (color) => {
    setSelectedColor((prevColor) => (prevColor === color ? null : color));
  };

  const handlePageClick = (page) => {
    setSelectedPage(page);
  };

  const toggleCart = () => {
    setIsCartVisible((prev) => !prev);
  };

  const handleAddToCart = (product) => {
    addToCart(product); 
  };

  const handleIncreaseQuantity = (productId) => {
    increaseQuantity(productId); 
  };

  const handleDecreaseQuantity = (productId) => {
    decreaseQuantity(productId); 
  };

  const handleRemoveFromCart = (productId) => {
    removeFromCart(productId); 
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceRange((prevRange) => ({
      ...prevRange,
      [name]: value ? parseInt(value, 10) : (name === 'min' ? 0 : Infinity),
    }));
  };

  const products = [
    { id: 1, name: 'Sweter Szary', price: 100, rating: 4, color: 'Szary', category: 'Swetry' },
    { id: 2, name: 'Sweter Czarny', price: 200, rating: 4.5, color: 'Czarny', category: 'Swetry' },
    { id: 3, name: 'Sweter Brązowy', price: 300, rating: 5, color: 'Brązowy', category: 'Swetry' },
    { id: 4, name: 'Sweter Beżowy', price: 400, rating: 4, color: 'Beżowy', category: 'Swetry' },
    { id: 5, name: 'Czapka Beżowa', price: 500, rating: 4.5, color: 'Beżowy', category: 'Czapki' },
    { id: 6, name: 'Czapka Brązowa', price: 150, rating: 5, color: 'Brązowy', category: 'Czapki' },
    { id: 7, name: 'Komin Czarny', price: 250, rating: 4, color: 'Czarny', category: 'Kominy' },
    { id: 8, name: 'Komin Szary', price: 350, rating: 4.5, color: 'Szary', category: 'Kominy' },
    { id: 9, name: 'Torba Beżowa', price: 450, rating: 5, color: 'Beżowy', category: 'Torby' },
    { id: 10, name: 'Torba Brązowa', price: 50, rating: 4, color: 'Brązowy', category: 'Torby' },
  ];

  const sortedProducts = [...products];
  if (selectedSort === 'Najtańsze') {
    sortedProducts.sort((a, b) => a.price - b.price);
  } else if (selectedSort === 'Najdroższe') {
    sortedProducts.sort((a, b) => b.price - a.price);
  } else if (selectedSort === 'Najwyższe Opinie') {
    sortedProducts.sort((a, b) => b.rating - a.rating);
  }

  const filteredProducts = sortedProducts.filter(
    (product) =>
      product.price >= priceRange.min &&
      product.price <= priceRange.max &&
      (!selectedCategory || product.category === selectedCategory) &&
      (!selectedColor || product.color === selectedColor)
  );

  return (
    <div className="Store">
      <header className="App-header">
        <div className="navbar">
          <div className="logo">
            <img src="/logo.png" alt="logo" />
          </div>
          <nav>
            <ul className="menu">
              <li className="home"><Link to="/">Home</Link></li>
              <li><Link to="/store">Store</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li className="cart-icon-container" onClick={toggleCart}>
                <FontAwesomeIcon icon={faCartShopping} className="cart-icon" />
                {cartItems.length > 0 && (
                  <span className="cart-badge">{cartItems.reduce((total, item) => total + item.quantity, 0)}</span>
                )}
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <div className="store-content">
        <div className="left-panel">
          <div className="sorting-options">
            <h2>Sortuj Produkty</h2>
            <ul>
              {['Najtańsze', 'Najdroższe', 'Najwyższe Opinie', 'Najczęściej Kupowane'].map((sortOption) => (
                <li
                  key={sortOption}
                  className={selectedSort === sortOption ? 'selected' : ''}
                  onClick={() => handleSortClick(sortOption)}
                >
                  {sortOption}
                </li>
              ))}
            </ul>
          </div>
          <hr /> 
          <div className="search-menu">
            <h2>Wyszukaj Produkty</h2>
            <form>
              <input type="text" placeholder="Szukaj..." />
              <button type="submit" className="search-btn">Szukaj</button>
            </form>
            <hr />
            <div className="price-section">
              <h3>Cena</h3>
              <div className="price-inputs">
                <div className="price-input">
                  <input
                    type="number"
                    name="min"
                    placeholder="od"
                    min="0"
                    onChange={handlePriceChange}
                  />
                  <span>zł</span>
                </div>
                <span>-</span>
                <div className="price-input">
                  <input
                    type="number"
                    name="max"
                    placeholder="do"
                    min="0"
                    onChange={handlePriceChange}
                  />
                  <span>zł</span>
                </div>
              </div>
            </div>
            <hr />
            <div className="categories-section">
              <h3>WYSZUKAJ KATEGORIE</h3>
              <div className="categories">
                {['Swetry', 'Czapki', 'Kominy', 'Torby'].map((category) => (
                  <div
                    key={category}
                    className={`category ${selectedCategory === category ? 'selected' : ''}`}
                    onClick={() => handleCategoryClick(category)}
                  >
                    {category}
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="colors-section">
              <h3>WYBIERZ KOLOR</h3>
              <div className="colors">
                {[
                  { name: 'Czarny', colorCode: '#000000' },
                  { name: 'Szary', colorCode: '#808080' },
                  { name: 'Beżowy', colorCode: '#F5F5DC' },
                  { name: 'Brązowy', colorCode: '#8B4513' },
                ].map((color) => (
                  <div
                    key={color.name}
                    className={`color ${selectedColor === color.name ? 'selected' : ''}`}
                    onClick={() => handleColorClick(color.name)}
                  >
                    <span
                      className="color-box"
                      style={{ backgroundColor: color.colorCode }}
                    ></span>
                    {color.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="right-panel">
          <div className="product-grid">
            <h1>Nasze Produkty</h1>
            <div className="product-grid-container">
              {filteredProducts.map((product) => (
                <div key={product.id} className="product-card">
                  <img src={`/placeholder.jpg`} alt={product.name} />
                  <h3 className="product-name" style={{ fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {product.name}
                  </h3>
                  <p className="price">Cena: {product.price} zł</p>
                  <div className="product-color">
                    Kolor: 
                    <span
                      className="color-box"
                      style={{
                        backgroundColor: product.color === 'Czarny' ? '#000000' :
                                         product.color === 'Szary' ? '#808080' :
                                         product.color === 'Beżowy' ? '#F5F5DC' :
                                         product.color === 'Brązowy' ? '#8B4513' : 'transparent',
                        display: 'inline-block',
                        marginLeft: '5px',
                        width: '20px',
                        height: '20px',
                        borderRadius: '3px',
                        border: '1px solid #ccc' 
                      }}
                    ></span>
                  </div>
                  <div className="rating">
                    {[...Array(5)].map((_, i) => {
                      if (i < Math.floor(product.rating)) {
                        return <i key={i} className="fa-solid fa-star"></i>;
                      } else if (i < product.rating) {
                        return <i key={i} className="fa-regular fa-star-half-stroke"></i>;
                      } else {
                        return <i key={i} className="fa-regular fa-star"></i>;
                      }
                    })}
                  </div>
                  <button onClick={() => handleAddToCart(product)}>Dodaj do Koszyka</button>
                </div>
              ))}
            </div>
          </div>
          <div className="pagination">
            {[1, 2, 3].map((page) => (
              <div
                key={page}
                className={`page-number ${selectedPage === page ? 'selected' : ''}`}
                onClick={() => handlePageClick(page)}
              >
                {page}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={`cart-sidebar ${isCartVisible ? 'visible' : ''}`}>
        <div className="cart-content">
          <button className="close-cart" onClick={toggleCart}>X</button> 
          <h2>Koszyk</h2>
          <hr className="cart-divider" />
          {cartItems.length > 0 ? (
            <>
              <ul>
                {cartItems.map((item, index) => (
                  <React.Fragment key={item.id}>
                    <li className="cart-item">
                      <img src={`/placeholder.jpg`} alt={item.name} className="cart-item-image" /> 
                      <div className="cart-item-details">
                        <p>{item.name}</p>
                        <p>{item.totalPrice} zł</p>
                        <p>Ilość: {item.quantity}</p>
                        <div className="cart-item-controls">
                          <button onClick={() => handleIncreaseQuantity(item.id)}>+</button>
                          <button onClick={() => handleDecreaseQuantity(item.id)}>-</button>
                          <button onClick={() => handleRemoveFromCart(item.id)}>Usuń</button>
                        </div>
                      </div>
                    </li>
                    {index < cartItems.length - 1 && <hr className="cart-item-divider" />}
                  </React.Fragment>
                ))}
              </ul>
              <hr className="cart-divider" />
              <p className="cart-total">OSTATECZNA KWOTA: {cartItems.reduce((total, item) => total + item.totalPrice, 0)} zł</p> {/* Total amount */}
              <div className="cart-actions">
                <Link to="/payment">
                  <button className="buy-button">KUP</button>
                </Link>
                <button
                  className="clear-button"
                  onClick={() => cartItems.forEach(item => removeFromCart(item.id))}
                >
                  USUŃ WSZYSTKO
                </button>
              </div>
            </>
          ) : (
            <p>Twój koszyk jest pusty.</p>
          )}
        </div>
      </div>
      <div className="Footer">
        <img src="/logo.png" alt="Logo" />
      </div>
      <div className="Footer-bar">
        <div className="footer-left">
          COZY FANG 2025 <br />
          WSZELKIE PRAWA ZASTRZEŻONE
        </div>
        <div className="footer-icons">
          <img src="/ig.png" alt="Instagram" />
          <img src="/fb.png" alt="Facebook" />
          <img src="/yt.png" alt="YouTube" />
        </div>
        <div className="footer-right">
          <a href="/regulamin">Regulamin</a>
          <a href="/polityka-prywatnosci">Polityka Prywatności</a>
        </div>
      </div>
    </div>
  );
}

export default Store;
